import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { Tooltip } from "../../../utils/local-antd";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../components/AtiraIcon";
import { Button } from "../../../components/Button";
import { Flex } from "../../../components/Flex";
import { Rounded } from "../../../theme/Rounded";
import { Shadow } from "../../../theme/Shadow";
import { Spacing } from "../../../theme/Spacing";
import { ThemeType } from "../../../theme/Theme";

const Container = styled(Flex)`
  gap: ${Spacing.m};
  padding: 0 ${Spacing.m};
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${Shadow.SM};
  align-items: center;
  position: relative;
  width: 100%;
`;

const StatusButton = styled(Button)<{ enabled: boolean }>`
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: ${({ theme, enabled }) => theme[enabled ? "success" : "danger"]};
  position: absolute;
  top: calc(${Spacing.s} / 2);
  html[dir="rtl"] & {
    right: calc(${Spacing.s} / 2);
  }
  html[dir="ltr"] & {
    left: calc(${Spacing.s} / 2);
  }
`;

type SectionProps = {
  children: React.ReactNode;
  enabled?: boolean;
  icon: IconProp;
  iconColor: keyof ThemeType;
};

export const IntegrationSection: React.FC<SectionProps> = ({
  children,
  enabled,
  icon,
  iconColor,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "common" });

  return (
    <Container>
      <AtiraIcon icon={icon} size="3x" color={iconColor} />
      {children}
      <Tooltip title={t(enabled ? "enabled" : "disabled")}>
        <StatusButton
          enabled={Boolean(enabled)}
          icon={faCircle}
          iconWidth="xs"
        />
      </Tooltip>
    </Container>
  );
};
